require('./accountDebitsChangeAccountView.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ commons
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { LoadingSection } = require('commonsComponents/loadingSection');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { formatText } = require('core/i18n').i18n;
// @ components
const { AccountDebitChangeAccountInfoBox } = require('components/contactCenter/accountDebitChange/accountDebitChangeAccountInfoBox/accountDebitChangeAccountInfoBox');
const { AccountDebitChangeAccountDetailsBox } = require('components/contactCenter/accountDebitChange/accountDebitChangeAccountDetailsBox/accountDebitChangeAccountDetailsBox');
const { AccountDebitChangeStep1 } = require('components/contactCenter/accountDebitChange/accountDebitChangeStep1/accountDebitChangeStep1');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
// @ constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { ACCOUNT_CHANGE_RECEIPT } = require('constants/contactCenter/operationTypes');

class AccountDebitsChangeAccountView extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
    }

    componentWillMount() {

        const {
            match: { params: { accountId, receiptNumber } },
            requestAccountDebits,
            immAccounts,
            setReceiptNumber,
            setCurrentAccountId,
            reset,
        } = this.props;
        const account = immAccounts.getIn(['byId', accountId]);

        reset();
        requestAccountDebits(account);
        setReceiptNumber(receiptNumber);
        setCurrentAccountId(accountId);
    }

    handleCancel() {
        const cancelPath = `/myprofile/accounts`;
        this.props.history.push(cancelPath);
    }

    buildPreleaveCancelModal() {

        const { immChangeReceiptAccount } = this.props;
        const showCancelModal = immChangeReceiptAccount.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    filterAccounts(immAccountsList, immAccountsMap) {
        let filterAccountIds = [];

        const { match: { params: { accountId } } } = this.props;
        immAccountsList.forEach(accountIdItem => {
            const account = immAccountsMap.get(accountIdItem);
            const isAccountProduct = account.get('newProduct') === '300';
            const isAccountProductSubType = account.get('accountType') !== '804';
            if (isAccountProduct && isAccountProductSubType && accountIdItem !== accountId) {
                filterAccountIds.push(accountIdItem);
            }
        });

        return filterAccountIds;
    }

    buildWizard(immAccounts, immAccountDebits) {
        const {
            match: { params: { accountId, receiptNumber } },
            immProfile,
            immChangeReceiptAccount,
            validateStep,
            setVisibleStep,
            setWillCancel,
            handleFinish,
            setDestinationAccountId
        } = this.props;
        const filteredAccounts = this.filterAccounts(immAccounts.get('byOrder'), immAccounts.get('byId'));
        const clientName = immProfile.get('nombreCliente');

        const immSteps = immChangeReceiptAccount.get('steps');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: handleFinish,
            cancel: this.handleShowCancelModal
        };

        const destinationAccountId = immChangeReceiptAccount.getIn(['steps', FIRST_STEP, 'destinationAccountId']);
        const immDestinationAccount = immAccounts.getIn(['byId', destinationAccountId]);
        let operationParams = {};

        if (immDestinationAccount) {
            const product = immDestinationAccount.get('product');
            const contractNumber = immDestinationAccount.get('contractNumber');

            const originAccount = `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`;

            const optional1 = 'CTA';

            operationParams = {
                originAccount,
                optional1,
            };
        }

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immChangeReceiptAccount.get('visibleStep')}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <AccountDebitChangeStep1
                        immAccounts={immAccounts}
                        immAccountDebits={immAccountDebits}
                        immChangeReceiptAccount={immChangeReceiptAccount}
                        params={{ accountId, receiptNumber }}
                        filteredAccounts={filteredAccounts}
                        clientName={clientName}
                        setAccountId={setDestinationAccountId}
                        validateStep={validateStep}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={false}
                    immFinalButton="accountDebitChange-verifyOTPConfirm"
                >
                    <VerifyOtpStep
                        operationType={ACCOUNT_CHANGE_RECEIPT}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    onHandleGoBack() {
        const depositsPath = `/myprofile/accounts`;
        this.props.history.push(depositsPath);
    }

    buildSuccessfulFeedback() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText('accountDebitChangeFeedbackSuccess-title')}
                subtitle={formatText('accountDebitChangeFeedbackSuccess-subtitle')}
                textLink={formatText('accountDebitChange-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText('accountDebitChangeFeedbackError-title')}
                subtitle={formatText('accountDebitChangeFeedbackError-subtitle')}
                textLink={formatText('accountDebitChange-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildContent() {
        const {
            match: { params: { accountId, receiptNumber } },
            immAccountDebits,
            immChangeReceiptAccount,
            immAccounts
        } = this.props;

        const {
            isFetching,
            inProgress,
            submitSuccessful,
            error,
        } = immChangeReceiptAccount.toJS();

        let content;

        if (isFetching || inProgress) {
            content = (<LoadingSection />);
        } else if (submitSuccessful) {
            content = this.buildSuccessfulFeedback();
        } else if (error || !immAccountDebits.hasIn([accountId, 'byId', receiptNumber])) {
            content = this.buildErrorFeedback();
        } else {
            const preleaveCancelModal = this.buildPreleaveCancelModal();
            content = (
                <div>
                    <div className="col-xs-8">
                        {this.buildWizard(immAccounts, immAccountDebits)}
                    </div>
                    <div className="col-xs-4">
                        <AccountDebitChangeAccountInfoBox
                            params={{ accountId, receiptNumber }}
                            immAccounts={immAccounts}
                            immAccountDebits={immAccountDebits}
                        />
                        <AccountDebitChangeAccountDetailsBox
                            params={{ accountId, receiptNumber }}
                            immAccounts={immAccounts}
                            immAccountDebits={immAccountDebits}
                        />
                    </div>
                    {preleaveCancelModal}
                </div>
            );
        }

        return content;
    }

    render() {
        const { match: { params: { accountId } }, immAccounts } = this.props;
        const accountAlias = immAccounts.getIn(['byId', accountId, 'alias']);
        const content = this.buildContent();

        const mappingBreadcrumb = [
            {
                text: accountAlias,
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-debits'),
                url: `/myprofile/accounts/${accountId}/debits`
            },
            {
                text: formatText('accountDebitChange-title'),
                url: ''
            }
        ];

        return (
            <section className="debits-change-account-view">
                <OKHeaderCC
                    title="accountDebitChange-title"
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="debits-change-account-view__body">
                    {content}
                </div>
            </section>
        );
    }
}

AccountDebitsChangeAccountView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccountDebits: PropTypes.object,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    requestAccountDebits: PropTypes.func,
    match: PropTypes.object,
    changeReceiptAccountConf: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    setDestinationAccountId: PropTypes.func.isRequired,
    setCurrentAccountId: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setReceiptNumber: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immChangeReceiptAccount: PropTypes.object,
    showCancelModal: PropTypes.func.isRequired,
};

module.exports.AccountDebitsChangeAccountView = withRouter(AccountDebitsChangeAccountView);
